export default {
  title: "Work to Perform",
  text_only_one_work_order:
    "There’s 1 <b class='text-info'>Work Order</b> referencing this <b class='text-info'>Item</b>.",
  text_more_than_one_work_order:
    "Select from the <b class='text-info'>Work Orders</b> or go to the filtered <b class='text-info'>Work Orders</b> list!",
  performed: "Performed",
}
